"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialsTypeEnum = exports.CredentialsToJSON = exports.CredentialsFromJSONTyped = exports.CredentialsFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CredentialsFromJSON(json) {
    return CredentialsFromJSONTyped(json, false);
}
exports.CredentialsFromJSON = CredentialsFromJSON;
function CredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'passwordCredentials': !(0, runtime_1.exists)(json, 'passwordCredentials') ? undefined : (0, _1.PasswordCredentialsFromJSON)(json['passwordCredentials']),
        'legacyCredentials': !(0, runtime_1.exists)(json, 'legacyCredentials') ? undefined : (0, _1.LegacyCredentialsFromJSON)(json['legacyCredentials']),
        'useAutologin': !(0, runtime_1.exists)(json, 'useAutologin') ? undefined : json['useAutologin'],
    };
}
exports.CredentialsFromJSONTyped = CredentialsFromJSONTyped;
function CredentialsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'passwordCredentials': (0, _1.PasswordCredentialsToJSON)(value.passwordCredentials),
        'legacyCredentials': (0, _1.LegacyCredentialsToJSON)(value.legacyCredentials),
        'useAutologin': value.useAutologin,
    };
}
exports.CredentialsToJSON = CredentialsToJSON;
/**
* @export
* @enum {string}
*/
var CredentialsTypeEnum;
(function (CredentialsTypeEnum) {
    CredentialsTypeEnum["Password"] = "password";
    CredentialsTypeEnum["Legacy"] = "legacy";
})(CredentialsTypeEnum = exports.CredentialsTypeEnum || (exports.CredentialsTypeEnum = {}));
//# sourceMappingURL=Credentials.js.map